import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,  // Automatically uses the correct URL based on the environment
  timeout: 10000,
});

export default api;



